import { useState } from "react";
import { toast } from "sonner";
import { Facebook, Linkedin, Link2, MessageCircle } from "lucide-react";

export default function ShareButtons({ project }) {
  const [copied, setCopied] = useState(false);
  const base =
    (typeof window !== "undefined" && window.location.origin) ||
    "https://yachconstruction.com";
  const url = `${base}/projects?p=${project.id}`;
  const text = `${project.name} — ${project.location} · by Yach Construction`;

  const share = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Copy failed");
    }
  };

  const btn =
    "w-10 h-10 flex items-center justify-center border border-[#D9D4C7] hover:border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#FAF9F6] transition-colors duration-300";

  return (
    <div className="flex items-center gap-3 mt-6" data-testid="share-buttons">
      <span className="font-grotesk text-[10px] uppercase tracking-[0.24em] text-[#4A4A4A] mr-2">
        Share
      </span>
      <a href={share.whatsapp} target="_blank" rel="noreferrer noopener" className={btn} aria-label="Share on WhatsApp" data-testid="share-whatsapp">
        <MessageCircle className="w-4 h-4" />
      </a>
      <a href={share.facebook} target="_blank" rel="noreferrer noopener" className={btn} aria-label="Share on Facebook" data-testid="share-facebook">
        <Facebook className="w-4 h-4" />
      </a>
      <a href={share.linkedin} target="_blank" rel="noreferrer noopener" className={btn} aria-label="Share on LinkedIn" data-testid="share-linkedin">
        <Linkedin className="w-4 h-4" />
      </a>
      <button onClick={copy} className={btn} aria-label="Copy link" data-testid="share-copy">
        <Link2 className="w-4 h-4" />
      </button>
      {copied && (
        <span className="font-grotesk text-[10px] uppercase tracking-[0.22em] text-[#8C7A6B]">
          Copied
        </span>
      )}
    </div>
  );
}
